// Tiny helpers for deciding whether the seed-inventory entry points should
// render for a given locationId. On the prod CMS build we restrict to
// well-known test fridges so a tester can't accidentally wipe a real fridge's
// inventory. Staging/dev builds have no restriction.
//
// We infer "is prod build" by comparing against the default AppSync endpoint
// in src/config.js. If REACT_APP_APPSYNC_ENDPOINT is unset, the build is
// pointed at the prod endpoint.

import config from '../../config';

const PROD_TESTING_LOCATION_PREFIXES = ['FLAB_TEST_'];

export function isProdCmsBuild() {
  const endpoint =
    process.env.REACT_APP_APPSYNC_ENDPOINT || config.appsync.ENDPOINT;
  return endpoint === config.appsync.ENDPOINT;
}

export function canSeedLocation(locationId) {
  if (!locationId) return false;
  // Prod enforces an allowlist so an errant click can't wipe a real fridge.
  // Staging/dev are unrestricted.
  if (isProdCmsBuild()) {
    return PROD_TESTING_LOCATION_PREFIXES.some((p) => locationId.startsWith(p));
  }
  return true;
}
